module.exports = __webpack_public_path__ + "images/tencent_docs/import-b76b7a3944dd8c96073abd2b806b64c0.svg";